import { defineMessages } from 'react-intl';

export default defineMessages({
  stepOneParagraphOneSR: {
    id: 'coachmarks.Apply.SR.Step.One.ParagraphOne',
    defaultMessage: '<p>We automatically placed your affiliated programs in the favorites section if you have one.</p>',
    description: 'Coachmarks apply step one paragraph one for SR',
  },
  stepOneParagraphOne: {
    id: 'coachmarks.Apply.Step.One.ParagraphOne',
    defaultMessage: '<p>On this page, you’ll build your application — and eventually submit it!</p>',
    description: 'Coachmarks apply step one paragraph one',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Apply.Step.One.ParagraphTwo',
    defaultMessage:
      '<p>You can find your favorite programs on the right side of the screen.</p><p>Your child’s application is on the left side of the screen. Drag, drop, and re-order programs to your true order of preference. Order matters!</p>',
    description: 'Coachmarks apply step one paragraph two',
  },
  stepOneParagraphTwoPK: {
    id: 'coachmarks.Apply.Step.One.ParagraphTwo.PK',
    defaultMessage:
      '<p>You can find your favorite programs on the right side of the screen.</p><p>Your child’s application is on the left side of the screen. Drag, drop, and re-order programs to your true order of preference. Order matters!</p>',
    description: 'Coachmarks apply step one paragraph two',
  },
  stepOneParagraphThree: {
    id: 'coachmarks.Apply.Step.One.ParagraphThree',
    defaultMessage:
      '<p>You may not be able to add some programs if you’re not eligible, or if you need to schedule an assessment first. Find that information next to each program.</p>',
    description: 'Coachmarks apply step one paragraph three',
  },
  stepOneParagraphThreePK: {
    id: 'coachmarks.Apply.Step.One.ParagraphThree.PK',
    defaultMessage:
      '<p>You may not be able to add some programs if you’re not eligible. Find that information next to each program.</p>',
    description: 'Coachmarks apply step one paragraph three PK',
  },
  stepOneParagraphThreeKindergarten: {
    id: 'coachmarks.Apply.Step.One.ParagraphThree.Kindergarten',
    defaultMessage:
      '<p>You may not be able to add some programs if you’re not eligible. Find that information next to each program.</p>',
    description: 'Coachmarks apply step one paragraph three kindergarten',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Apply.Step.Two.ParagraphOne',
    defaultMessage:
      '<p>View “Your Application” to see the programs you’ve added to your application, or to search for and add any program directly.</p>',
    description: 'Coachmarks apply step two paragraph One',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Apply.Step.Two.ParagraphTwo',
    defaultMessage:
      '<p>Drag and drop programs to reorder them. Click on programs in the list to view details in order to make final decisions about how to order your list.</p>',
    description: 'Coachmarks apply step two paragraph Two',
  },
  stepTwoParagraphThree: {
    id: 'coachmarks.Apply.Step.Two.ParagraphThree',
    defaultMessage: '<p>It’s important to list programs in your true order of preference. Order matters!</p>',
    description: 'Coachmarks apply step two paragraph Three',
  },
  stepThree: {
    id: 'coachmarks.Apply.Step.Three',
    defaultMessage:
      'It’s important to apply to {maxPrograms} programs! Once you’ve filled up your list, you can prepare to submit it (during the application period) by clicking the button at the bottom of your application.',
    description: 'Coachmarks apply step three',
  },
  stepThreeMiddleSchool: {
    id: 'coachmarks.Apply.Step.Three.middleschool',
    defaultMessage:
      'Once you’ve finished your list, you can prepare to submit it by clicking the button at the bottom of your application.',
    description: 'Coachmarks apply step three Middle School',
  },
  stepThreeKindergarten: {
    id: 'coachmarks.Apply.Step.Three.kindergarten',
    defaultMessage:
      'Once you’ve finished your list, you can prepare to submit it (during the application period) by clicking the button at the bottom of your application.',
    description: 'Coachmarks apply step three Kindergarten',
  },
  stepThreeNewSchools: {
    id: 'coachmarks.Apply.Step.Three.newschools',
    defaultMessage:
      'Once you’ve finished your list, you can prepare to submit it (during the application period) by clicking the button at the bottom of your application.',
    description: 'Coachmarks apply step three New Schools',
  },
});
